import { createInstanceWithChildren } from '../../../../utils/dynamic-items-utils';
import { ProductThumbnailWithQuantities } from '../../../components/product-items/product-thumbnail-with-quantities';

export const GroupedProductsContainer = createInstanceWithChildren({
  id: 'container',
  contentTypeId: 'dynamic-collections-renderer',
  styles: {
    classes: ['d-block', 'grouped-products-container'],
  },
  children: [
    {
      id: 'array-renderer',
      contentTypeId: 'dynamic-elements-array-renderer',
      if: ['EQ', [{ provider: 'id:root', property: 'hasItems' }, true]],
      inputs: {
        sliceStart: 0,
        sliceEnd: 999,
        propertyToUse: 'itemData',
        items$: { provider: 'id:root', property: 'groupedProductData' },
        contentType: {
          contentTypeId: 'dynamic-collections-renderer',
          styles: {
            classes: ['d-block', 'grouped-products', 'py-2', 'px-3'],
          },
          data: {
            itemData: {
              provider: 'parent',
              property: 'itemData',
            },
          },
          children: [
            {
              contentTypeId: 'dynamic-elements-simple-text',
              styles: {
                classes: ['h3', 'd-block', 'mb-2', 'border-bottom'],
              },
              inputs: {
                text: {
                  provider: 'parent',
                  property: 'itemData',
                  transform: function (itemData: [string]) {
                    const monthNames = [
                      'Jan',
                      'Feb',
                      'Mar',
                      'Apr',
                      'May',
                      'Jun',
                      'Jul',
                      'Aug',
                      'Sep',
                      'Oct',
                      'Nov',
                      'Dec',
                    ];
                    return monthNames[Number(itemData[0])];
                  }.toString(),
                },
              },
            },
            {
              contentTypeId: 'dynamic-elements-array-renderer',
              styles: {
                classes: ['row'],
              },
              inputs: {
                contentType: ProductThumbnailWithQuantities,
                propertyToUse: 'itemData',
                items$: {
                  provider: 'parent',
                  property: 'itemData',
                  transform: function (itemData: [string, any]) {
                    return itemData[1];
                  }.toString(),
                },
              },
            },
          ],
        },
      },
    },
  ],
});
